import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "checkbox-container" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxComponent',
  props: {
    modelValue: { type: Boolean },
    customClass: {},
    hasError: { type: Boolean },
    errorMessage: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const checkstatus = ref( props.modelValue);

const emit = __emit;

const handleChange = (event: Event) => {
    const target = event.target as HTMLInputElement; 
    checkstatus.value = target.checked;
    emit('update:modelValue', target.checked);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        class: _normalizeClass(['custom-checkbox', _ctx.customClass])
      }, [
        _createElementVNode("input", {
          type: "checkbox",
          checked: checkstatus.value,
          onChange: handleChange
        }, null, 40, _hoisted_2),
        _createElementVNode("span", {
          class: _normalizeClass(['custom-checkbox__box', { 'has-error': _ctx.hasError }])
        }, null, 2)
      ], 2),
      _renderSlot(_ctx.$slots, "label")
    ]),
    (_ctx.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})